import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { Pane } from 'evergreen-ui';
import { request } from 'cademy-shared-web';
import { Environment } from 'services/Environment';

const PaypalPaymentScreen = ({ onPaymentComplete, order }) => {
    return (
        <Pane>
            <h1>Paypal</h1>

            <PayPalScriptProvider
                options={{ 'client-id': Environment.PAYPAL_CLIENT_ID, currency: 'GBP' }}
            >
                <PayPalButtons
                    style={{ layout: 'vertical' }}
                    createOrder={async (data, actions) => {
                        const { data: orderRef } = await request.post(
                            '/apps/paypal/start-payment',
                            {
                                record_type: 'order',
                                record_ref: order._id,
                            }
                        );

                        return orderRef;
                    }}
                    onApprove={async (data, actions) => {
                        await actions.order.capture();
                        onPaymentComplete();
                    }}
                />
            </PayPalScriptProvider>
        </Pane>
    );
};

export default PaypalPaymentScreen;
